import TourContainer from "../../../Components/BonusUi/Tour/TourContainer";

const Tour = () => {
  return <TourContainer />;
};

export default Tour;
